import { Button, Stack, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import DefentSheet from "@/features/HealthScore/components/DefentSheet";
import IconLoader from "@/features/Common/components/IconLoader";
import { convertPxToRem } from "@/utils";

interface LifestyleFlyupModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConnect?: () => void;
}

export default function LifestyleFlyupModal({
  isOpen,
  onClose,
  onConnect,
}: LifestyleFlyupModalProps) {
  const { t } = useTranslation();

  const handlePrimaryButtonClick = () => {
    onConnect?.();
    onClose();
  };

  return (
    <DefentSheet
      expanded={isOpen}
      onClose={onClose}
      onExpandedChange={(expanded) => {
        if (!expanded) onClose();
      }}
    >
      <Stack spacing={4} alignItems="center" textAlign="center" px={2} py={4}>
        <IconLoader
          icon="LifestyleIcon"
          color="primary"
          sx={{ fontSize: convertPxToRem(70) }}
        />

        <Stack spacing={2}>
          <Typography variant="h3" fontWeight={700} component="h2">
            {t("LifestyleFlyupModal.title")}
          </Typography>
          <Typography variant="body1" color="neutral.600">
            {t("LifestyleFlyupModal.description")}
          </Typography>
        </Stack>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handlePrimaryButtonClick}
        >
          {t("LifestyleFlyupModal.cta")}
        </Button>
      </Stack>
    </DefentSheet>
  );
}
